"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeDataChooser = void 0;
const DataChooserProps_1 = require("../props/DataChooserProps");
function makeDataChooser(fnc) {
    return (props) => fnc(Object.assign(Object.assign({}, DataChooserProps_1.DefaultDataChooserProps), props));
}
exports.makeDataChooser = makeDataChooser;
exports.default = makeDataChooser;
